// Third-party
import AppBar from '@mui/material/AppBar';
import ToolBar from '@mui/material/Toolbar';

// Assets
import { useTheme } from '@mui/material';
import appLogo from '../../../assets/appLogo.png';

const PosLayout = () => {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  return (
    <AppBar
      elevation={1}
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 100,
        background: isLight ? 'white' : '',
      }}
    >
      <ToolBar>
        <img src={appLogo} width={70} height={70} alt="appLogo" />
      </ToolBar>
    </AppBar>
  );
};

export {
  PosLayout,
};
